import WidgetModule from "@eisinc/Overrides/Widgets/AccountSettings/AccountSettingsHeader";

export * from "@eisinc/Overrides/Widgets/AccountSettings/AccountSettingsHeader";

export default WidgetModule;
